import React, { useEffect, useState } from 'react';
import styles from './News.module.scss';

// axios
import axios from 'axios';

// components
import NewsItem from './NewsItem/NewsItem';
import Details from '../../Modals/Details/Details';

const News = () => {
  const [news, setNews] = useState([]);
  const [newsModalState, setNewsModalState] = useState({
    title: '',
    text: '',
    active: false
  });

  useEffect(() => { 
    const fetchData = async () => {
      try {
        const res = await axios.get("/get-news");
        setNews(res.data);

      } catch (err) {
        console.log(err);
      }
      
    };

    fetchData();
  }, []);

  return (
    <div className={styles.news}>
      <div className={styles.title} id='scrollNews'>Новости</div>
      <div className={styles.carousel}>
        {news.map((news, index) =>
          <NewsItem
            key={index}
            date={news.date} 
            text={news.text}
            url={news.url}
            full_image_url={news.full_image_url}
            onOpenNews={() => setNewsModalState({
              title: `Новость от ${news.date}`,
              text: news.text,
              active: true
            })}
          />
        )}
      </div>
      {newsModalState.active ? (
        <Details
          title={newsModalState.title}
          text={newsModalState.text}
          badge="Новости"
          setDetailsModalState={setNewsModalState}
        />
      ) : null}
    </div>
  )
}

export default React.memo(News);
